export default __webpack_public_path__ + "static/media/bg-footer.503d94da.png";